import { mutationOptions, queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import { FORMS_API_BASE_ENDPOINT } from "./constants";
import { api } from "./apiClient";
import { queryClient } from "./queryClient";

const BASE_ENDPOINT = `${FORMS_API_BASE_ENDPOINT}/news`;

const keys = {
  all: () => ["news"] as const,
} as const;

const NewsSchema = z.object({
  id: z.string(),
  header: z.string(),
  body: z.string(),
  createdAt: z.string(),
});

export const newsQueryOptions = () =>
  queryOptions({
    queryKey: keys.all(),
    queryFn: () => api.get(BASE_ENDPOINT, { schema: z.array(NewsSchema) }),
    throwOnError: true,
  });

export const markAsReadNewsMutationOptions = () =>
  mutationOptions({
    mutationFn: () => api.post(BASE_ENDPOINT),
    onSuccess: () => queryClient.invalidateQueries(),
  });
